import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';
// import AudioPlayer from './AudioPlayer';
import { colors, bottomBarColor } from '../../lib/theme';
import { appleStoreUrl, bottomBarHeight, playStoreUrl, showVideo, staticAssetsPrefix } from '../../lib/utils';
import { logBlogAppClick } from '../../actions';


const AudioPlayer = dynamic(
  () => import('./AudioPlayer'),
  { ssr: false }
)

class TopBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: 12000
    };
  }
  componentDidMount() {
    this.setState({ windowWidth: window.innerWidth });
  }

  onAppClick = (appType) => {
    console.log(location.pathname);
    logBlogAppClick(location.pathname, appType);
  }
  // const TopBar = ({ audioInfo, audioPlayState }) => (


  render() {
    const { windowWidth } = this.state;
    const isMobile = windowWidth < 767;
    const { audioInfo, audioPlayState, userDetails } = this.props;
    const showMobileApps = isMobile && userDetails && userDetails.uid;

    return (
      <div>
        {(!audioInfo || (Object.keys(audioInfo).length === 0 && audioInfo.constructor === Object)) ? <></> :
          <div className="fix-bottom">
            {audioInfo ?
              <div className='special-video'>
                {!showVideo(audioInfo) ? <div key='audio-key'><audio id="main-player"
                  // crossOrigin="anonymous"
                  // ref={this.setAudioTagRef} style={{ display: 'none' }}
                  // // onDurationChange={this.onAudioStart}
                  // onLoadStart={this.audioLoadStart}
                  // onLoadedMetadata={this.onAudioStart}
                  // onError={this.onAudioError}
                  // onTimeUpdate={this.method} onEnded={this.onAudioEnd}
                  // // playbackrate={audioPlaybackRate}
                  // // defaultPlaybackRate={audioPlaybackRate}
                  // // src={audioInfo.enclosure.link} type={audioInfo.enclosure.type}
                  controls={false} autoPlay={false} loop={false}
                  data-plyr-config='{ "controls": [], "hideControls": true }'
                >
                  {/* <source src={audioInfo.enclosure.link} /> */}
                  Your browser does not support the
                  <code>audio</code> element.
                </audio></div> :
                  <div key='video-key' style={{}}>
                    <video id="main-player" playsInline controls>
                      {/* <source src="/path/to/video.mp4" type="video/mp4" /> */}
                      {/* <!-- Captions are optional -->
            <track kind="captions" label="English captions" src="/path/to/captions.vtt" srclang="en" default /> */}
                    </video></div>}
              </div>
              : ''
            }
            <AudioPlayer audioPlayState={audioPlayState} />
          </div>}
        {showMobileApps &&
          <div className='apps-bottom'>
            <div className='text-center'>
              {/* Try our Android | iOS apps for better experience on mobile. */}
              <div className='apps'>
                <a onClick={this.onAppClick.bind(this, 'ios')} style={{ marginRight: '1em' }}
                  href={appleStoreUrl + '&pt=120962850&ct=publicCollection&mt=8'} target='_blank' rel="noopener noreferrer nofollow">
                  <img style={{ width: '100px' }} src={`${staticAssetsPrefix}/static/images/app-store/app_store.svg`} />
                </a>
                <a onClick={this.onAppClick.bind(this, 'android')} href={playStoreUrl} target='_blank' rel="noopener noreferrer">
                  <img style={{ height: '44px', maxWidth: '108px', transform: 'translateY(0)' }} src={`${staticAssetsPrefix}/static/images/app-store/google-play-badge.svg`} />
                </a>
              </div>
            </div>
          </div>
        }
        <style jsx>
          {`
            .fix-bottom{
                // border-radius: 0.5em 0.5em 0 0;
                position: fixed;
                z-index: 30;
                bottom: ${showMobileApps ? '40px' : 0};
                // background: -webkit-gradient(linear, left top, right bottom, color-stop(0%, #122B44), color-stop(100%, hsla(223, 22%, 21%, 0.99))); // ${bottomBarColor}; // ${colors.primary};
                // opacity: 0.98;
                // background-image: radial-gradient( circle 909px at 8.3% 51.5%,  rgba(45,165,229,1) 0%, rgba(126,199,239,1) 74.9% ); 
                // background-image: radial-gradient( circle 909px at 8.3% 51.5%,  #3897f0 0%, rgba(126,199,239,1) 74.9% ); // vv imp
                // background-image: radial-gradient( circle 909px at 8.3% 51.5%,  ${colors.primary} 0%, rgba(126,199,239,1) 74.9% ); // imp
                background: #151515;
                width: 100%;
                left: 0;
                overflow-x: hidden;
                // padding: 0 8px;
                height: ${bottomBarHeight};
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                flex-direction: column;
                justify-content: center;
                color: white;
                z-index: 10000;
            }
              .apps-bottom {
                position: fixed;
                bottom: 0;
                background: #151515;
                width: 100%;
                z-index: 10000;
              }
                .apps {
                  text-align: center;
                }
            .special-video {
              position: fixed;
              right: 0;
              bottom: ${bottomBarHeight};
              width: 30%;
              }
          `}
        </style>
      </div>
    )
  }
}

TopBar.propTypes = {
  audioInfo: PropTypes.object,
  userDetails: PropTypes.object,
  audioPlayState: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    // personalValues: state.personalValues,
    userDetails: state.userDetails,
    audioInfo: state.audioState,
    audioPlayState: state.audioPlayState
  }
};

export default connect(mapStateToProps, null)(TopBar)
// export default TopBar